module.exports = __webpack_public_path__ + "static/Personio-d901d513dde1ab78cecae73c3bed7bf7.jpg";